import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Token property - Definition */
export class DocsBlockTokenPropertyDefinition extends DocsBlockPropertyDefinition {
}
